import { render } from "./PosSyncStatus.vue?vue&type=template&id=24c278c4&scoped=true"
import script from "./PosSyncStatus.vue?vue&type=script&lang=js"
export * from "./PosSyncStatus.vue?vue&type=script&lang=js"

import "./PosSyncStatus.vue?vue&type=style&index=0&id=24c278c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c278c4"]])

export default __exports__